export default __webpack_public_path__ + "static/media/logo.5027629b.png";